import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/Header";
import { TrustBadges } from "@/components/TrustBadges";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Principles } from "@/components/Principles";
import { OurTeam } from "@/components/OurTeam";
import { KeyFacts } from "@/components/KeyFacts";
import { BedAvailability } from "@/components/BedAvailability";
import { CareTypes } from "@/components/CareTypes";
import { CQCRating } from "@/components/CQCRating";
import { ReviewRating } from "@/components/ReviewRating";
import { Reviews } from "@/components/Reviews";
import { LeaveReview } from "@/components/LeaveReview";
import { Facilities } from "@/components/Facilities";
import { FoodAndDining } from "@/components/FoodAndDining";
import { Activities } from "@/components/Activities";
import { FAQ } from "@/components/FAQ";
import { Careers } from "@/components/Careers";
import { LocationMap } from "@/components/LocationMap";
import { Footer } from "@/components/Footer";
import { AvailabilityWidget } from "@/components/AvailabilityWidget";
import { CookieBanner } from "@/components/CookieBanner";
import { PrivacyPolicy } from "@/components/PrivacyPolicy";
import { CookiePolicy } from "@/components/CookiePolicy";
import { Toaster } from "@/components/ui/sonner";
import AdminPanel from "@/components/AdminPanel";
import { EnquiryProvider } from "@/components/EnquiryContext";

function HomePage() {
  return (
    <EnquiryProvider>
      <div className="App">
        <Header />
        <TrustBadges />
        <main>
          <Hero />
          <KeyFacts />
          <About />
          <Principles />
          <OurTeam />
          <BedAvailability />
          <CareTypes />
          <ReviewRating />
          <LeaveReview />
          <Reviews />
          <CQCRating />
          <Facilities />
          <FoodAndDining />
          <Activities />
          <Careers />
          <FAQ />
          <LocationMap />
        </main>
        <Footer />
        <AvailabilityWidget />
      </div>
    </EnquiryProvider>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>
      <CookieBanner />
      <Toaster position="top-right" />
    </Router>
  );
}

export default App;
